var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'filters-container',
		'animate__animated',
		'animate__faster',
		_vm.ui.animation ]},_vm._l((_vm.ui.filters),function(filter){return _c('div',{staticClass:"filter"},[_c('span',{staticClass:"filter-name"},[_vm._v(" "+_vm._s(((filter.title) + ":"))+" ")]),_c('div',{staticClass:"d-flex flex-column mt-1"},_vm._l((filter.options),function(option){return _c('div',{class:[
					'option',
					{
						'option-active': option.ui.active,
					} ],on:{"click":function($event){return _vm.optionToggle(option)}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }